import { loadIssueInfoByIssueKey } from '@pressreader/content';
import { IArticle } from '@pressreader/content-types';

import { loadArticleBookmarks } from './share';

function* loadArticleDataForContextMenu(article: IArticle) {
    if (article.issue) {
        yield* loadIssueInfoByIssueKey(article.issue.issueKey);
    }

    yield* loadArticleBookmarks(article.primaryArticleId);
}

export { loadArticleDataForContextMenu };
